import React from "react";
import ProgressBar from "react-bootstrap/ProgressBar";
import { useTranslation } from "../../i18n/TranslationProvider";

const OnboardingProgress = ({ onboardingPercent }) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-between w-full">
      <h5 className="m-0 text-base md:text-lg">{t("onboardingprogress.create_account")}</h5>
      <div className="text-sm md:text-base ml-auto mr-2">
        {t("onboardingprogress.progress")}: {onboardingPercent}%
      </div>
      <ProgressBar
        now={onboardingPercent}
        max={100}
        variant="info"
        srOnly
        label={`Step ${onboardingPercent} / 100`}
      />
    </div>
  );
};

export default OnboardingProgress;